export const SEARCH_ENGINE_MODAL_X_PADDING = 30;
export const SEARCH_ENGINE_MODAL_BOTTOM_PADDING = 10;

export const SEARCH_ENGINE_PANEL_MAX_WIDTH = 1000;
